<div class="context-menu" [ngStyle]="getMenuStyle()" (click)="onMenuClick($event)">
  <div class="bg-white border border-slate-200 rounded-lg shadow-xl py-1 min-w-[180px] z-[10000]">
    <div *ngFor="let item of items" [class.opacity-50]="item.disabled" [class.cursor-not-allowed]="item.disabled"
      [class.cursor-pointer]="!item.disabled" [class.border-t]="item.divider" [class.border-slate-200]="item.divider"
      [class.mt-1]="item.divider" [class.pt-1]="item.divider"
      class="px-3 py-1.5 text-[13px] text-slate-700 hover:bg-slate-50 transition-colors flex items-center justify-between group relative"
      (click)="onItemClick(item, $event)" 
      (mousedown)="onItemMouseDown(item, $event)"
      (mouseenter)="onItemMouseEnter(item, $event)"
      (mouseleave)="onItemMouseLeave()">
      <div class="flex items-center gap-3">
        <!-- Color Square for status -->
        <div *ngIf="item.color" [style.background-color]="item.color"
          class="w-3.5 h-3.5 border border-slate-400 flex-shrink-0"></div>

        <i *ngIf="item.icon" [ngClass]="item.icon" [style.color]="item.iconColor || item.color || 'var(--primary)'" class="w-4 h-4 flex-shrink-0"></i>
        <span class="tracking-tight">{{ item.label }}</span>
      </div>

      <!-- Submenu indicator -->
      <i *ngIf="item.children && item.children.length > 0" class="fas fa-caret-right text-slate-400 text-[10px]"></i>

      <!-- Submenu Recursive Rendering -->
      <div *ngIf="activeSubmenu && activeSubmenu.action === item.action" class="absolute left-full top-[-5px] pl-1"
        (mouseenter)="onItemMouseEnter(item, $event)" (mouseleave)="onItemMouseLeave()">
        <app-context-menu [items]="item.children || []" [rowData]="rowData" (itemClick)="itemClick.emit($event)"
          (close)="closeMenu()"></app-context-menu>
      </div>
    </div>
  </div>
</div>